import React from 'react'
import LayoutHeader from '../../../layout/LayoutHeader'
import { useNavigate } from 'react-router';
import RedirectCard from '../../../components/More/RedirectCard';

export default function SettingOption() {
    const navigate = useNavigate();

    const handleRestartWalkthrough = () => {
        // Clear all walkthrough and tutorial flags
        localStorage.removeItem('dizeeWalkthroughCompleted');
        localStorage.removeItem('hasSeenWalkthrough');
        localStorage.removeItem('hasSeenTutorial');
        localStorage.removeItem('onboardingCompletedDate');
        localStorage.removeItem('dailyDigestLastShown');
        localStorage.removeItem('accountSetupCompleted');
        
        // Clear checklist state
        localStorage.removeItem('setupChecklistCompleted');
        localStorage.removeItem('setupChecklistItems');
        
        // Clear tour state
        localStorage.removeItem('tourCompleted');
        sessionStorage.removeItem('tourActive');
        sessionStorage.removeItem('tourCurrentSection');
        sessionStorage.removeItem('tourStartTime');
        sessionStorage.removeItem('tourMessages');
        
        // Set flag to trigger walkthrough on next landing page visit
        localStorage.setItem('isNewSignup', 'true');
        
        // Navigate to landing page to start walkthrough
        navigate('/');
    };

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white'>Select an option</p>
                    <p onClick={() => navigate('/')} className='text-white cursor-pointer'>Go back</p>
                </div>

                <div onClick={() => navigate('/more/setting/profile')} className="w-full cursor-pointer">
                    <RedirectCard txt="Profile" dotimgclss={false} link={"/more/setting/profile"} />
                </div>
                
                <div onClick={() => navigate('/more/setting/subscription')} className="w-full cursor-pointer">
                    <RedirectCard txt="Subscription" dotimgclss={false} link={"/more/setting/subscription"} />
                </div>

                <div onClick={() => navigate('/more/setting/advanced/team-management')} className="w-full cursor-pointer">
                    <RedirectCard txt="Team" dotimgclss={false} link={"/more/setting/advanced/team-management"} />
                </div>

                <div onClick={() => navigate('/more/setting/advanced')} className="w-full cursor-pointer">
                    <RedirectCard txt="Advanced" dotimgclss={false} link={"/more/setting/advanced"} />
                </div>

                <div className="py-6"></div>

                <button
                    className="text-white text-left py-2 rounded-lg w-full px-4 hover:bg-[rgba(255,255,255,0.1)] transition-colors"
                    onClick={handleRestartWalkthrough}
                >
                    Restart Walkthrough & Tutorial
                </button>

            </div>
        </LayoutHeader>
    )
}
